import React from 'react';

import { Image, LinkIcon, Text } from 'reaxl';

export default ({ image = {}, owner = {} }) => (
    <>
        <Image
            src={
                image.src ||
                'https://content.autotrader.com/content/dam/autotrader/shared/img/dealer-financing-default-tile.png'
            }
            alt={image.alt}
            className="center-block margin-bottom-2"
        />
        <Text>{`Get pre-qualified with ${owner.name || ''}`} </Text>
        <LinkIcon>Visit dealer website</LinkIcon>
    </>
);
